import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { PROC_DIAGRAMS } from "@/components/visuals/TechArt";
import { PRODUCTION } from "@/content/homeContent";

export const Production = () => {
  return (
    <Section id="production-section" tone="dark" className="bg-strato-softblack">
      <Reveal>
        <SectionHeading
          microLabel={PRODUCTION.microLabel}
          title={PRODUCTION.title}
          description={PRODUCTION.description}
        />
      </Reveal>

      {/* phases */}
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {PRODUCTION.phases.map((phase, i) => {
          const Diagram = PROC_DIAGRAMS[phase.diagram];
          return (
            <Reveal key={phase.id} delay={i * 0.06}>
              <div
                data-testid={`production-phase-${phase.id}`}
                className="relative flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-6"
              >
                <div className="flex items-center justify-between">
                  <div className="h-14 w-14 rounded-xl border border-white/10 bg-white/[0.03] p-2.5">
                    {Diagram ? <Diagram tone="dark" /> : null}
                  </div>
                  <MicroLabel className="text-white/35">{phase.index}</MicroLabel>
                </div>
                <h3 className="mt-5 font-display text-lg font-medium tracking-[-0.01em] text-white">
                  {phase.title}
                </h3>
                <p className="mt-2 text-sm leading-[1.6] text-white/60">
                  {phase.description}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>

      {/* specs strip */}
      <Reveal delay={0.12}>
        <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-4 border-t border-white/10 pt-8">
          {PRODUCTION.specs.map((s) => (
            <div key={s.label} className="flex items-baseline gap-3">
              <MicroLabel className="text-white/40">{s.label}</MicroLabel>
              <span className="font-display text-base font-medium text-white">
                {s.value}
              </span>
            </div>
          ))}
        </div>
      </Reveal>
    </Section>
  );
};
